export const featuresSchema = {
    type: 'object',
    required: ['card'],
    properties: {
        card: {
            type: 'object',
            required: ['SPORTS', 'LIBRARY', 'CITIZEN'],
            properties: {
                SPORTS: {
                    type: 'objet',
                    properties: {
                        canUpdateExpDate: { type: 'boolean' },
                    },
                },
                LIBRARY: {
                    type: 'objet',
                    properties: {
                        canUpdateExpDate: { type: 'boolean' },
                    },
                },
                CITIZEN: {
                    type: 'objet',
                    properties: {
                        canUpdateExpDate: { type: 'boolean' },
                    },
                },
            },
        },
    },
};
